/**
 * Коды языков (B1).
 *
 * Живут в общем пакете, а не только на фронте: сервер тоже должен знать этот
 * список — он хранит выбранный язык пользователя и шлёт на нём письма.
 * Разъехавшись, эти два списка дают ровно то, ради чего файл и появился:
 * интерфейс на украинском и письма на русском.
 *
 * Названия написаны на самих языках: человек, ищущий свой язык в списке,
 * не обязан знать, как он называется по-английски.
 */
export const languages = [
  { code: 'en', label: 'English' },
  { code: 'ru', label: 'Русский' },
  { code: 'es', label: 'Español' },
  { code: 'pt', label: 'Português' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'fi', label: 'Suomi' },
  { code: 'ro', label: 'Română' },
  { code: 'uk', label: 'Українська' },
  { code: 'kk', label: 'Қазақша' },
] as const;

export type LanguageCode = (typeof languages)[number]['code'];

/** Английский — исходный: на нём пишутся ключи, он же запасной. */
export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const supportedLanguages: LanguageCode[] = languages.map((item) => item.code);

export const isSupportedLanguage = (code: string): code is LanguageCode =>
  (supportedLanguages as string[]).includes(code);

/**
 * Приводит `ru-RU` к `ru`, а незнакомое — к запасному.
 *
 * Браузер и заголовок Accept-Language отдают язык с регионом, а словари
 * и шаблоны писем именуются без него.
 */
export function normalizeLanguage(value: string | null | undefined): LanguageCode {
  if (!value) return DEFAULT_LANGUAGE;
  const base = value.split('-')[0]?.toLowerCase() ?? '';
  return isSupportedLanguage(base) ? base : DEFAULT_LANGUAGE;
}
